import { render } from "./CalendarView.vue?vue&type=template&id=06ba30bc&scoped=true"
import script from "./CalendarView.vue?vue&type=script&lang=js"
export * from "./CalendarView.vue?vue&type=script&lang=js"

import "./CalendarView.vue?vue&type=style&index=0&id=06ba30bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ba30bc"]])

export default __exports__